import { useTranslation } from 'react-i18next';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { FormTextField } from '../../formComponents/FormTextField';
import { SettingsRow } from '../../formComponents/SettingsRow';
import { Language } from '../../../api';

type InformationSectionProps = {
  language: Language;
  disabled: boolean;
};
export const InformationSectionLanguageTab = ({ language, disabled }: InformationSectionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const textBoxWidth = isSmallScreen ? '100%' : 500;
  return (
    <Grid container flexDirection="column">
      <SettingsRow label={t('editOrderPage.orderPageName')}>
        <FormTextField
          isFieldUpdate
          width={textBoxWidth}
          fieldName={`label.${language}`}
          disabled={disabled}
          caption={t('editOrderPage.orderPageNameCaption')}
        />
      </SettingsRow>
      <SettingsRow label={t('editOrderPage.activityLabel')}>
        <FormTextField
          isFieldUpdate
          width={textBoxWidth}
          fieldName={`activity_label.${language}`}
          disabled={disabled}
          caption={t('editOrderPage.activityLabelCaption')}
        />
      </SettingsRow>
    </Grid>
  );
};
